import { generalIconsList } from 'react-scale/components/elements/general-icons';

export const navigationLinks = {
  title: {
    text: 'products'
  },
  links: [
    {
      text: 'Use Cases',
      href: '#use-cases'
    },
    {
      text: 'How It Works',
      href: '#how-it-works'
    },
    {
      text: 'Quality Assurance',
      href: '#quality-assurance'
    },
    {
      text: 'Customers',
      href: '#customers'
    }
  ]
};

export const heroTitle = 'Image';
export const heroSubtitle = 'The comprehensive annotation platform for images.';

export const useCasesTitle = 'Computer Vision';

export const useCasesSubtitle =
  'Develop highly accurate perception models to locate and identify objects of various classes, classify entire images, extract structured text from images, and more.';

export const useCasesCases = [
  {
    title: 'Object Detection',
    text: 'Locate and precisely identify objects of various classes.',
    list: [
      'Autonomous Vehicles and ADAS',
      'Product Identification',
      'Damage and Defect Detection',
      'Health Diagnostics'
    ],
    img: {
      url: '/static/img/website/big/products/image/object-detection.jpg',
      alt: '',
      width: 600,
      height: 440,
      cover: true
    }
  },
  {
    title: 'Classification',
    text: 'Classify images according to their visual contents.',
    list: [
      'Search and Ad Relevance',
      'Recommendation Systems',
      'Precision Agrigulture',
      'Policy Enforcement'
    ],
    img: {
      url: '/static/img/website/big/products/image/classification.jpg',
      alt: '',
      width: 600,
      height: 440,
      cover: true
    }
  },
  {
    title: 'Text Recognition',
    text: 'Identify and extract structured text from images.',
    list: ['License Plate Identification', 'ID Verification', 'Product Cataloging'],
    img: {
      url: '/static/img/website/big/products/image/text-recognition.svg',
      alt: '',
      width: 600,
      height: 440,
      cover: true
    }
  }
];

export const hiwTitle = 'Easy to Start, Optimize and Scale';

export const hiwSubtitle =
  'Build models you can trust while maximizing operational efficiency and reducing the cost of ML projects.';

export const featuresFeatures = [
  {
    img: generalIconsList.hexagon,
    title: 'ML-Powered Data Labeling',
    text: 'Machine learning powered pre-labeling and active tooling such as superpixel segmentation as well as ML-based quality checks accurately annotate large volumes of images efficiently and at high quality.'
  },
  {
    img: generalIconsList.award,
    title: 'Automated Quality Pipeline',
    text: 'Have confidence in the quality of annotated data. Quality assurance systems monitor and prevent errors. Confidence scores trigger varying levels and types of human review.'
  },
  {
    img: generalIconsList.labels,
    title: 'Comprehensive Label Support',
    text: 'Specify geometries for different classes (e.g. boxes for people, polygons for furniture, ellipses for plates). Enhance object detection by combining different geometries in a singular task.'
  },
  {
    img: generalIconsList.graph,
    title: 'Operational Excellence',
    text: 'Taxonomy changes can be implemented rapidly via automated personalized training and evaluation for flexibility on quality and annotation requirements. '
  },
  {
    img: generalIconsList.infinity,
    title: 'Data Input Flexibility',
    text: 'Submit images regardless of file format (e.g. jpg, tiff, png). Scale’s Data Engine even supports annotations for fisheye or extra-wide panoramic images.'
  },
  {
    img: generalIconsList.person,
    title: 'Configurable Tasks',
    text: 'Image tasks are composable. Configure image tasks to dynamically generate a classification task with consensus if a target object is unknown.'
  }
];

export const qaSubtitle =
  'ML-accelerated, human-in-the-loop data annotation for rapid turnaround and industry-leading quality.';

export const qaTexts = [
  'Image tasks submitted to the platform are first pre-labeled by our proprietary ML models, then manually annotated and reviewed by highly trained workers depending on heuristic and learned error detectors, ml model confidence scores, and other quality metrics.',
  'The resulting accuracy is consistently higher than what a human or synthetic labeling approach can achieve independently. '
];

export const customersSubtitle =
  'Scale Image is trusted by leading machine learning teams to develop more accurate models.';

export default navigationLinks;
